import React, { Fragment, useState } from 'react';
import Project from '../../api/project';
import { Link } from "react-router-dom";
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import CtaSection from '../../components/CtaSection/CtaSection';

const PortfolioPage = (props) => {

    const [activeFilter, setActiveFilter] = useState('all');

    const handleFilterClick = (filter) => {
        setActiveFilter(filter);
    }

    const filteredProjects = activeFilter === 'all'
        ? Project.slice(0, 40)
        : Project.slice(0, 40).filter(project => project.category === activeFilter);

    return (
        <Fragment>
            <main className="page_content about-page">
                <PageTitle pageTitle={'Our Portfolio'}  />
                <section className="portfolio_section section_space bg-light">
                    <div className="container">
                        <div className="filter_elements_nav">
                            <ul className="unordered_list justify-content-center">
                                <li className={activeFilter === 'all' ? 'active' : ''} onClick={() => handleFilterClick('all')}>See All</li>
                                <li className={activeFilter === 'booking' ? 'active' : ''} onClick={() => handleFilterClick('booking')}>Booking Platforms</li>
                                <li className={activeFilter === 'technology' ? 'active' : ''} onClick={() => handleFilterClick('technology')}>Designing</li>
                                <li className={activeFilter === 'Video' ? 'active' : ''} onClick={() => handleFilterClick('Video')}>Video Animations</li>
                                {/* <li className={activeFilter === 'analysis' ? 'active' : ''} onClick={() => handleFilterClick('analysis')}>Analysis</li>
                                <li className={activeFilter === 'marketing' ? 'active' : ''} onClick={() => handleFilterClick('marketing')}>Marketing</li> */}
                            </ul>
                        </div>
                        <div className="filter_elements_wrapper row">
                            {filteredProjects.map((project, prj) => (
                                <div className="col-lg-6" key={prj}>
                                    <div className="portfolio_block portfolio_layout_2">
                                        <div className="portfolio_image">
                                            <Link  className="portfolio_image_wrap bg-light" to=''>
                                                <img src={project.pImg} alt="Mobile App Design" />
                                            </Link>
                                        </div>
                                        <div className="portfolio_content">
                                            <h3 className="portfolio_title">
                                                <Link  to=''>
                                                    {project.title}
                                                </Link>
                                            </h3>
                                            <ul className="category_list unordered_list">
                                                <li><Link  to=''><i className="fa-solid fa-tags"></i> {project.thumb1}</Link></li>
                                                <li><Link  to=''><i className="fa-solid fa-building"></i> {project.thumb2}</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {/* <button className='video_btn'>
                                <span className='btn_icon'>
                                    <i className='fa-solid fa-play'></i>
                                </span>
                                <span className='btn_label'>hello</span>
                        </button> */}
                    </div>
                </section>

                <CtaSection />
            </main>
            <Scrollbar />
        </Fragment>
    )
};

export default PortfolioPage;
